<!-- 投诉与反馈表单 -->
<template>
	<el-dialog :title="$t('complaintTitle')" :visible.sync="visible" width="900px" top="5vh" center
		class="complaint-dialog" :before-close="handleClose" :close-on-click-modal="false">
		<div class="complaint-tip">{{$t('enquiryTipTitle')}}</div>
		<div class="complaint-tip">{{$t('complaintTipContent')}}</div>
		<div class="complaint-alert">{{$t('complaintTipAlert')}}</div>
		<el-form :model="complaintForm" :rules="complaintRules" ref="complaintForm" label-width="140px"
			class="complaint-form" label-position="top">
			<el-row>
				<el-col :span="8">
					<el-form-item :label="$t('complaintType')" prop="complaintType">
						<el-select v-model="complaintForm.complaintType" :placeholder="$t('selectPlaceholder')"
							class="form-select">
							<el-option :label="$t('productRelated')" value="product"></el-option>
							<el-option :label="$t('merchantRelated')" value="store"></el-option>
							<el-option :label="$t('serviceRelated')" value="service"></el-option>
							<el-option :label="$t('otherIssues')" value="other"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="16">
					<el-form-item :label="$t('contactEmail')" prop="memberEmail">
						<el-input v-model="complaintForm.memberEmail" :placeholder="$t('emailPlaceholder')"
							disabled></el-input>
					</el-form-item>
				</el-col>
			</el-row>

			<el-row>
				<el-col :span="24">
					<el-form-item :label="$t('complaintContent')" prop="complaintContent">
						<el-input type="textarea" v-model="complaintForm.complaintContent" :rows="4"
							:placeholder="$t('complaintContentPlaceholder')" maxlength="500" show-word-limit></el-input>
					</el-form-item>
				</el-col>
			</el-row>

			<el-row>
				<el-col :span="24">
					<el-form-item :label="$t('attachment')" prop="imageUrl">
						<el-upload :action="uploadUrl" ref="upload" :auto-upload="false" list-type="picture-card"
							:on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-success="handleSuccess"
							:on-error="handleError" multiple :headers="headers">
							<i class="el-icon-camera"></i>
						</el-upload>
						<el-dialog :visible.sync="dialogVisible" append-to-body top="5vh">
							<img width="100%" :src="dialogImageUrl" alt="">
						</el-dialog>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button @click="handleClose">{{ $t('cancel') }}</el-button>
			<el-button type="primary" @click="submitComplaint" :loading="isSubmit">{{ $t('confirm') }}</el-button>
		</span>
	</el-dialog>
</template>

<script>
	import API_DOMAINS from '@/api/core/config'
	import storage from "@/utils/storage.js";
	import complaintApi from '@/api/complaint'
	export default {
		name: 'ComplaintDialog',
		props: {
			visible: {
				type: Boolean,
				default: false
			},
			storeId: {
				type: String,
				default: null
			}
		},
		data() {
			return {
				localVisible: this.visible,
				complaintForm: {
					storeId: '', //被投诉商家ID
					complaintType: '',
					memberEmail: '', //联系邮箱
					complaintContent: '', //投诉内容
					attachmentUrls: '',
					expectedSolution: '', //期望解决方案
					imageUrl: ''
				},
				dialogImageUrl: '',
				dialogVisible: false,
				uploadedCount: 0, // 已上传成功的图片数量
				totalFilesToUpload: 0, // 需要上传的图片总数
				uploadUrl: API_DOMAINS.complaintUploadUrl,
				headers: {
					"accessToken": storage.getToken()
				},
				isSubmit: false,
			}
		},
		watch: {
			visible(val) {
				this.localVisible = val;
				if (val) {
					this.$nextTick(() => {
						this.$refs.complaintForm && this.$refs.complaintForm.resetFields();
						this.getUserInfo();
					})
				}
			},
			localVisible(val) {
				this.$emit('update:visible', val);
			}
		},
		computed: {
			complaintRules() {
				return {
					complaintType: [{
						required: true,
						message: this.$t('complaintTypeRequired'),
						trigger: 'change'
					}],
					memberEmail: [{
							required: false,
							message: this.$t('emailRequired'),
							trigger: 'blur'
						},
						{
							type: 'email',
							message: this.$t('emailInvalid'),
							trigger: 'blur'
						}
					],
					complaintContent: [{
							required: true,
							message: this.$t('complaintContentPlaceholder'),
							trigger: 'blur'
						},
						{
							min: 20,
							message: this.$t('descriptionLengthError'),
							trigger: 'blur'
						}
					],
					imageUrl: [{
						required: true,
						message: this.$t('attachmentRequired'),
						trigger: 'change'
					}]
				}
			}
		},
		methods: {
			//获取登录用户信息
			getUserInfo() {
				var userInfo = JSON.parse(storage.getUserInfo());
				this.complaintForm.memberEmail = userInfo.email;
			},
			handleClose() {
				this.$confirm(this.$t('closeComplaint'), this.$t('tip'), {
					confirmButtonText: this.$t('confirm'),
					cancelButtonText: this.$t('cancel'),
					type: 'warning'
				}).then(() => {
					this.localVisible = false;
				}).catch(() => {
					// 处理取消事件，避免报错
				})
			},
			submitComplaint() {
				//检查是否有选择图片，如果有设置imageUrl不为空，避开必填项检测
				if (this.$refs.upload && this.$refs.upload.uploadFiles.length > 0) {
					this.complaintForm.imageUrl = "sourcefind";
				}
				this.$refs.complaintForm.validate((valid) => {
					if (valid) {
						this.isSubmit = true;
						// 检查是否有选择的图片需要上传
						if (this.$refs.upload && this.$refs.upload.uploadFiles.length > 0) {
							// 初始化上传计数
							this.uploadedCount = 0;
							this.totalFilesToUpload = this.$refs.upload.uploadFiles.length;
							// 清空之前的图片数组
							this.complaintForm.attachmentUrls = [];
							// 开始上传图片
							this.$refs.upload.submit();
						} else {
							// 没有图片需要上传，直接执行保存操作
							this.saveComplaint();
						}
					}
				})
			},
			// 保存投诉操作
			async saveComplaint() {
				var data = {
					...this.complaintForm,
					storeId: this.storeId
				}
				const res = await complaintApi.submit(data);
				if (res.code == 200) {
					this.$message.success(this.$t('complaintSubmitted'));
					// 清除上传的图片信息
					if (this.$refs.upload) {
						// 清除上传文件列表
						this.$refs.upload.clearFiles();
						// 重置上传计数
						this.uploadedCount = 0;
						this.totalFilesToUpload = 0;
					}
					// 清除表单中的图片数组
					this.complaintForm.attachmentUrls = [];
					this.localVisible = false;
					this.$emit('save-callback', true)
				} else {
					this.$message.success(this.$t('complaintFailed'));
				}
				this.isSubmit = false;
			},
			resetForm() {
				this.complaintForm = {
					storeId: '', //被投诉商家ID
					complaintType: '',
					memberEmail: '', //联系邮箱
					complaintContent: '', //投诉内容
					attachmentUrls: '',
					expectedSolution: '' //期望解决方案
				}
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			// 上传成功回调
			handleSuccess(response, file, fileList) {
				// 将图片URL添加到表单中
				this.complaintForm.attachmentUrls.push(response.result);
				// 增加已上传计数
				this.uploadedCount++;
				// 判断是否所有图片都已上传完成
				if (this.uploadedCount === this.totalFilesToUpload) {
					// 所有图片上传完成，执行保存询价操作
					this.saveComplaint();
				}
			},
			// 上传失败回调
			handleError(err, file, fileList) {
				this.$message.error(this.$t('imageUploadFailed'));
				// 上传失败，重置上传计数，避免后续操作
				this.uploadedCount = 0;
				this.totalFilesToUpload = 0;
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			}
		}
	}
</script>

<style scoped>
	.complaint-tip {
		color: #666;
		font-size: 12px;
	}

	.complaint-alert {
		color: #D9001B;
		font-size: 12px;
	}

	.complaint-dialog {
		border-radius: 8px;
	}

	.complaint-dialog .el-dialog {
		border-radius: 8px;
	}

	.complaint-dialog .el-dialog__header {
		border-bottom: 1px solid #eee;
		padding-bottom: 15px;
	}

	.complaint-dialog .el-dialog__title {
		font-weight: 600;
	}

	.complaint-form {
		padding: 10px 20px;
	}

	.complaint-form .el-form-item {
		margin-bottom: 20px;
	}

	.complaint-form .el-form-item__label {
		font-weight: 500;
		color: #333;
	}

	.form-select {
		width: 95%;
	}

	.complaint-form .el-input__inner {
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		transition: border-color 0.2s;
	}

	.complaint-form .el-input__inner:hover {
		border-color: #c0c4cc;
	}

	.complaint-form .el-input__inner:focus {
		border-color: #0171F9;
	}

	.complaint-form .el-textarea__inner {
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		transition: border-color 0.2s;
	}

	.complaint-form .el-textarea__inner:hover {
		border-color: #c0c4cc;
	}

	.complaint-form .el-textarea__inner:focus {
		border-color: #0171F9;
	}

	.complaint-form .el-select .el-input__inner {
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		transition: border-color 0.2s;
	}

	.complaint-form .el-select .el-input__inner:hover {
		border-color: #c0c4cc;
	}

	.complaint-form .el-select .el-input__inner:focus {
		border-color: #0171F9;
	}

	.dialog-footer {
		display: flex;
		justify-content: right;
	}

	.dialog-footer .el-button {
		padding: 10px 30px;
		border-radius: 4px;
	}

	.dialog-footer .el-button--primary {
		background-color: #0171F9;
		border-color: #0171F9;
	}

	.dialog-footer .el-button--primary:hover {
		background-color: #0158d4;
		border-color: #0158d4;
	}

	:deep .el-input__inner {
		color: #000 !important;
		border: 1px solid #DCDFE6 !important;
	}

	:deep .el-form-item__label {
		margin-bottom: -18px;
	}
</style>